import { render, staticRenderFns } from "./resellers.vue?vue&type=template&id=4b5c62e4"
import script from "./resellers.vue?vue&type=script&lang=js"
export * from "./resellers.vue?vue&type=script&lang=js"
import style0 from "./resellers.vue?vue&type=style&index=0&id=4b5c62e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports